{
  "en": {
    "answers": [
      {
        "id": 1328435,
        "text": "H₂O",
        "is_right": true
      },
      {
        "id": 1328436,
        "text": "CO₂",
        "is_right": false
      },
      {
        "id": 1328437,
        "text": "NaCl",
        "is_right": false
      },
      {
        "id": 1328438,
        "text": "O₂",
        "is_right": false
      }
    ],
    "tags": [
      {
        "id": 9932,
        "name": "Single Choice"
      },
      {
        "id": 156068,
        "name": "Sample Question"
      }
    ],
    "text": "What is water chemically composed of?",
    "is_poll_question": false,
    "type": 2,
    "created_at": "2025-09-02T14:35:44.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:54:55.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "weblink": "https://quizacademy.de/tipps/#Tipps%20f%C3%BCr%20Quizfragen",
    "has_weblink": true,
    "explanation": "**Correct Answer:**\n* H₂O\n\n**Further Information:**\n* Water is a chemical compound consisting of two hydrogen atoms (H) and one oxygen atom (O).\n* Therefore, the chemical formula is H₂O.\n\n**Notes:**\n\n* Sample questions help you work more easily in QuizAcademy.\n* For single-choice questions, one correct and three to four incorrect options are ideal.\n* Too few incorrect answers make the question too easy, while too many or overly long answer texts can make it confusing.\n* Formulate questions briefly, clearly, and in simple language. Use keywords from your learning materials.\n* Questions should be short, ideally a single sentence, and phrased unambiguously. Stay on topic and focus on the most effective information.",
    "has_explanation": true,
    "num_answers": 4
  },
  "de": {
    "answers": [
      {
        "id": 1329021,
        "text": "H₂O",
        "is_right": true
      },
      {
        "id": 1329022,
        "text": "CO₂",
        "is_right": false
      },
      {
        "id": 1329023,
        "text": "NaCl",
        "is_right": false
      },
      {
        "id": 1329024,
        "text": "O₂",
        "is_right": false
      }
    ],
    "tags": [
      {
        "id": 9427,
        "name": "Musterfrage"
      },
      {
        "id": 9932,
        "name": "Single Choice"
      }
    ],
    "text": "Woraus besteht Wasser chemisch gesehen?",
    "is_poll_question": false,
    "type": 2,
    "created_at": "2025-09-03T08:00:33.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:01:32.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "weblink": "https://quizacademy.de/tipps/#Tipps%20f%C3%BCr%20Quizfragen",
    "has_weblink": true,
    "explanation": "**Korrekte Antwort:**\n* H₂O\n\n**Weiterführende Informationen:**\n\n* Wasser ist eine chemische Verbindung aus zwei Wasserstoff-Atomen (H) und einem Sauerstoff-Atom (O). \n* Daher lautet die chemische Summenformel H₂O.\n\n**Hinweise:**\n* Musterfragen helfen Dir, in QuizAcademy leichter zu arbeiten.\n* Für Single-Choice-Fragen sind eine richtige und drei bis vier falsche Antwortmöglichkeiten ideal.\n* Zu wenige falsche Antworten machen die Frage zu leicht, zu viele oder zu lange Antworttexte wirken unübersichtlich.\n* Formuliere die Fragen kurz, eindeutig und in einfacher Sprache. Nutze Schlüsselbegriffe („Keywords“) aus Deinen Lernunterlagen.\n\nDie Fragen sollten kurz formuliert werden, ideal sind einzelne Sätze und eine eindeutige Sprache. Nutze entsprechende „Keywords“ aus Deinen Skripten. Bleibe beim Thema und versuche nur die effektivsten Informationen aufzugreifen.",
    "has_explanation": true,
    "num_answers": 4
  }
}
